import React from 'react';
import {
  Dialog, Typography, Grid, IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from './modal.styles';

type WidthSizes = {
  xs?: number,
  sm?: number,
  md?: number,
  lg?: number,
  xl?: number,
}

const widthSizes: WidthSizes = {
  xs: 500,
  sm: 900,
  md: 1100,
  lg: 1600,
  xl: 1800,
};

type Props = {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode | React.ReactNode[];
  buttons?: React.ReactNode[];
  leftComponents?: React.ReactNode[];
  titleComponent?: React.ReactNode | React.ReactNode[];
  size?: keyof WidthSizes;
  minWidth?: number | string;
  maxWidth?: number;
  className?: string;
  innerClassName?: string;
  pageId?: string;
}

const Modal = ({
  title, leftComponents, open, onClose, children, buttons, size = 'sm',
  minWidth = 300, maxWidth, className, titleComponent,
  innerClassName,
}: Props) => {
  const classes = useStyles();
  return (
    <Dialog
      fullWidth={true}
      scroll='paper'
      open={open}
      onClose={onClose}
      classes={{ paper: `${classes.paper} ${className || ''}` }}
      PaperProps={{ style: { maxWidth: maxWidth || widthSizes[size], width: size === 'xs' ? 'auto' : undefined, minWidth } }}
    >
      <Grid className={classes.header}>
        <Grid className={classes.titleGrid}>
          {titleComponent ? titleComponent : <Typography className={classes.title}>{title}</Typography>}
          <Grid className={classes.leftComps}>
            {leftComponents}
          </Grid>
        </Grid>
        <Grid className={classes.buttonsGrid}>
          {buttons}
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={`${classes.closeButton} ${className}-button-close`}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid
        className={classes.children + ' ' + innerClassName}
      >
        {children}
      </Grid>
    </Dialog>
  );
};

export default Modal;
